<template lang="pug">
div
  section-banner 屏東人ㄟ店 
  .container
    .section
      div(:class="$style.sub")
        b-icon(
          pack="fas"
          icon="tags")
        div(:class="$style.subtitle")
          span 標籤搜尋
      .columns
        .column.is-8
          b-field(label="熱門標籤")
            b-taglist(:class="$style.taglist")
              b-button(type="is-info"
                @click="tagInput = []") 全部
              b-button(v-for="item in highlights"
                type="is-info"
                @click="tagInput = [item]") {{ item }}
        .column.is-4
          b-field(label="搜尋標籤")
            b-taginput(v-model="tagInput"
              :data="filteredTags"
              :open-on-focus="true"
              :maxtags="1"
              placeholder="輸入關鍵字搜尋"
              @typing="getFilteredTags")
      div(:class="$style.sub")
        b-icon(
          pack="fas"
          icon="store")
        div(:class="$style.subtitle")
          span 商店列表
      div(:class="$style.grid")
        div(v-for="item in items"
          :class="$style.item")
          .card(:class="$style.card")
            a.card-image(@click="current = item")
              base-url-provider(:filepath="item.images[0]")
                template(v-slot="{ url }")
                  figure.image.is-4by3
                    img(:class="$style.cover" :src="url" :alt="item.name")
            .card-content(:class="$style.cardContent")
              p.subtitle.has-text-primary.has-text-weight-bold {{ item.name }}
              p
                span(:class="$style.label") 負責人：
                span {{ item.principal || "-" }}
              p
                span(:class="$style.label") 服務項目：
                span {{ item.products }}
              p
                span(:class="$style.label") 營業時間：
                span {{ item.openTime || "-" }}
              p
                span(:class="$style.label") 電話：
                span {{ item.phoneNumber || "-" }}
              p
                span(:class="$style.label") 地址：
                span {{ item.address || "-" }}
            footer.card-footer
              a.card-footer-item(@click="current = item") 介紹
              a.card-footer-item(v-if="item.address"
                :href="`https://www.google.com.tw/maps/place/${item.address}?hl=zh-TW`"
                target="_blank") 地圖
              a.card-footer-item(v-if="item.link"
                :href="item.link.startsWith('http') ? item.link : `http://${item.link}`"
                target="_blank") 網站
        b-modal(:active="current ? true : false"
            animation="fade"
            has-modal-card
            @close="current = null")
            .modal-card(v-if="current")
              .modal-card-body
                .title {{ current.name }}
                .content(:class="$style.cardContent") {{ current.introduction }}
                figure.image(v-for="img in current.images"
                  :key="img"
                  :class="$style.image")
                  base-url-provider(:filepath="img")
                    template(v-slot="{ url }")
                      img(:src="url" :alt="current.name")
              .modal-card-foot
                b-button.app-m-auto(type="is-danger"
                  outlined
                  @click="current = null") 離開
        div.has-text-centered.has-text-grey-light(v-if="nomore" style="flex: 0 0 100%;") 沒有更多商店囉
        div(v-else :class="[$style.item, $style.more]")
          b-button(type="is-warning" size="is-large" @click="fetchItems(tag, lastDoc)") 顯示更多商店
</template>

<script>
import SectionBanner from "@/components/SectionBanner.vue";
import BaseUrlProvider from "@/components/BaseUrlProvider.vue";

export default {
  name: "Shops",
  components: {
    SectionBanner,
    BaseUrlProvider
  },
  data() {
    return {
      highlights: ["食", "衣", "住", "行", "育", "樂", "其他"],
      items: [],
      tags: [],
      filteredTags: [],
      current: null,
      tagInput: [],
      lastDoc: null,
      limit: 50,
      nomore: false
    };
  },
  computed: {
    tag() {
      return this.tagInput[0] || null;
    }
  },
  watch: {
    tag: {
      async handler(val) {
        this.lastDoc = null;
        if (val) {
          await this.fetchItems(val);
        } else {
          await this.fetchItems();
        }
      },
      deep: true
    }
  },
  created() {
    this.fetchItems();
    this.fetchTags();
  },
  methods: {
    async fetchItems(tag, lastDoc) {
      this.nomore = false;

      let query = this.$f.db.collection("shops");

      if (tag) {
        query = query.where("tags", "array-contains", tag);
      }

      query = query.orderBy("order").limit(this.limit);

      if (lastDoc) {
        query = query.startAfter(lastDoc);
      } else {
        this.items = [];
      }

      const snap = await query.get();

      const items = snap.docs.map(doc => {
        const data = doc.data();
        data.id = doc.id;
        return data;
      });
      this.items = this.items.concat(items);

      this.lastDoc = snap.docs[snap.docs.length - 1];

      if (snap.size < this.limit) {
        this.nomore = true;
      }
    },
    async fetchTags() {
      const snap = await this.$f.db
        .collection("configs")
        .doc("tags")
        .get();
      const { items } = snap.data();
      this.tags = items;
      this.filteredTags = items;
    },
    getFilteredTags(text) {
      this.filteredTags = this.tags.filter(
        tag =>
          tag
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0
      );
    }
  }
};
</script>
<style module lang="sass">
.cover
  object-fit: cover
.cardContent
  letter-spacing: .05rem
  p
    margin-bottom: .5rem
  .label
      font-weight: bold
.link
  width: 100%
  height: 100%
  text-align: center

.grid
  display: flex
  justify-content: flex-start
  align-items: stretch
  flex-wrap: wrap
.item
  flex: 0 0 100%
  padding: 1rem
  +tablet
    flex: 0 0 50%
  +desktop
    flex: 0 0 33%
.image
  margin: .5rem 0

.sub
  position: relative
  margin: pxRem(32) 0
  &:after
    +size(pxRem(100), 2px)
    content: ''
    position: absolute
    left: 0
    bottom: pxRem(-8)
    background-color: $warning
  > *
    display: inline-block
  .subtitle
    padding: 0 pxRem(8)
    font-weight: bold
    color: $grey

.taglist
  > *
    margin: .2rem

.more
  display: flex
  justify-content: center
  align-items: center
</style>
